import * as _ from "lodash";

export default class ConferenceRoles {
	static Host = 0;
	static Guest = 1;
	static Participant = 2;

	static getRoleName(val) {
		return _.keys(this).find(r => this[r] === val);
	}
}